import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Box,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const LogoutModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout(); // Clear local data
    onClose();
    navigate('/login'); // Redirect to login page
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#1A1A1A",
          borderRadius: "20px",
          border: "1px solid #333333",
          padding: "8px",
          minWidth: "400px"
        }
      }}
    >
      <DialogContent sx={{ padding: "40px 32px 32px 32px", textAlign: "center" }}>
        {/* Logout Confirmation Message */}
        <Typography sx={{ 
          fontSize: "28px", 
          fontWeight: 600,
          color: "#FFFFFF",
          marginBottom: 3
        }}>
          Logout
        </Typography>
        
        <Typography sx={{ 
          fontSize: "18px", 
          color: "#CCCCCC",
          marginBottom: 5,
          lineHeight: 1.4
        }}>
          Are you sure you want to logout?
        </Typography>

        {/* Action Buttons */}
        <Box sx={{ 
          display: "flex", 
          gap: 2, 
          justifyContent: "center",
          alignItems: "center"
        }}>
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              borderColor: "#555555",
              color: "#CCCCCC",
              backgroundColor: "transparent",
              borderRadius: "25px",
              padding: "12px 32px",
              fontWeight: 600,
              textTransform: "none",
              fontSize: "16px",
              minWidth: "120px",
              "&:hover": {
                borderColor: "#777777",
                backgroundColor: "rgba(255, 255, 255, 0.05)"
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleLogout}
            sx={{
              backgroundColor: "#E1AD01",
              color: "#000000",
              borderRadius: "25px",
              padding: "12px 32px",
              fontWeight: 600,
              textTransform: "none",
              fontSize: "16px",
              minWidth: "120px",
              "&:hover": {
                backgroundColor: "#B8941F"
              }
            }}
          >
            Logout
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutModal;